import { isNumber } from 'lodash';

import { fNumber } from 'src/utils/format-number';

export function groupByCategory(inputArray) {
  const groupedByCategory = {};

  inputArray
    .sort((a, b) => a.data_repository.order > b.data_repository.order)
    .forEach((item) => {
      const { data_repository, ponderation_group } = item;
      const categoryName =
        ponderation_group ||
        (data_repository.data_categories ? data_repository.data_categories.name : 'Autre');

      if (!groupedByCategory[categoryName]) {
        groupedByCategory[categoryName] = [];
      }

      groupedByCategory[categoryName].push(item);
    });

  return groupedByCategory;
}

export function groupBySubcategory(inputArray) {
  const groupedByCategory = {};

  inputArray
    .sort((a, b) => a.data_repository.order > b.data_repository.order)
    .forEach((item) => {
      const { data_repository, ponderation_group } = item;
      const subcategoryName =
        ponderation_group ||
        (data_repository.data_subcategories
          ? data_repository.data_subcategories.name
          : data_repository.data_categories?.name || 'Autre');

      if (!groupedByCategory[subcategoryName]) {
        groupedByCategory[subcategoryName] = [];
      }

      groupedByCategory[subcategoryName].push(item);
    });

  return groupedByCategory;
}

export const formatValue = (value) => {
  if (!value) return undefined;
  if (!isNumber(value)) return value;
  if (value > 0) return fNumber(value);
  return undefined;
};

export const calculateEndOfLifeImpact = ({
  manufacturingImpact,
  endOfLifeImpactPercentage,
  reuseLine,
  forceFullWaste = false,
}) => {
  if (!endOfLifeImpactPercentage) return 0;

  let totalPercentage;
  if (forceFullWaste) {
    totalPercentage = 1;
  } else {
    totalPercentage = reuseLine
      ? reuseLine.waste_percentage / 100 + reuseLine.backup_percentage / 100
      : 1;
  }

  const impact = manufacturingImpact * totalPercentage * (endOfLifeImpactPercentage / 100);

  return impact;
};

export const calculateEndOfLifeImpactWithLifespan = ({
  manufacturingImpact,
  endOfLifeImpactPercentage,
  reuseLine,
  averageLifespan,
}) => {
  if (!endOfLifeImpactPercentage) return 0;

  if (!reuseLine) {
    return (manufacturingImpact * (endOfLifeImpactPercentage / 100)) / averageLifespan;
  }

  const wasteImpact =
    ((manufacturingImpact * (reuseLine.waste_percentage / 100) +
      manufacturingImpact * (reuseLine.backup_percentage / 100)) *
      (endOfLifeImpactPercentage / 100)) /
    averageLifespan;

  return wasteImpact;
};

/**
 * Calcule l'impact de reboot avec réemploi
 */
export const calculateRebootImpact = ({
  manufacturingImpact,
  rebootImpactPercentage,
  averageLifespan,
  reuseLine,
  endOfLifeImpact,
}) => {
  if (!reuseLine || !rebootImpactPercentage) return 0;
  if (reuseLine.reuse_percentage === 0) return 0;

  const rebootManufacturing = manufacturingImpact * (reuseLine.reuse_percentage / 100);
  const totalWithoutReuse = (rebootManufacturing + endOfLifeImpact) / averageLifespan;
  // Impact avec réemploi
  const totalWithReuse =
    (rebootManufacturing * (1 + rebootImpactPercentage / 100)) / (averageLifespan + 2);

  // La différence représente l'économie réalisée
  const impact = totalWithoutReuse - totalWithReuse;
  return impact;
};
